import * as React from 'react'
import { Col, Container, Row } from 'reactstrap'

import { IAppContextProps, withAppContext } from "../../context/AppContext"
import * as Model from '../../models'
import { DelayTextbox } from '../form'
import * as Layout from '../layout'
import Item from './Item'

interface IState {
  searchKeyword: string
}

class PageList extends React.Component<IAppContextProps, IState> {
  public constructor(props: IAppContextProps) {
    super(props)

    this.state = {
      searchKeyword: ""
    }
  }

  public render() {
    const state = this.props.appcontext.getProductState()
    const action = this.props.appcontext.getProductAction()

    const products = action.datasForDisplay(this.state.searchKeyword)
    const { hasMore }  = state

    return (
      <Container>
        {/* { isFormOpen && (
          <FormCreate {...props} formTitle="新增貨品" />
        )}
        <Row>
          <Col xs={12}>
            <Button color="primary" className="pull-right" onClick={props.openCreateForm}>新增貨品</Button>
          </Col>
        </Row> */}
        <Layout.RowSeparator />
        <DelayTextbox value="" onDelayTriggered={this.handleSearchBoxChange} placeholder="搜尋貨品" />
        <Layout.RowSeparator />
        <Row>
          { products.count() <= 0 && (
            ( this.isSearching() ? 
              <Col xs={12}>沒有找到符合「{ this.state.searchKeyword }」的資料</Col>
              :
              <Col xs={12}>沒有資料</Col>
            )
          )}
        </Row>
        <Layout.ColumnGallery hasMore={hasMore} onLoadMore={this.handleLoadMore}>
          <Row>
            { products.map((product: Model.IProduct, index: number) => (
              <Col key={product.productid} className="mt-2 mb-2" xs={12} md={6} xl={4}>
                <Layout.IndexOf index={index} filteredListCount={products.count()} wholeListCount={state.offlineDatas.count()} hasMore={state.hasMore} />
                <Item {...this.props} product={product} />
              </Col>
            ))}
          </Row>
        </Layout.ColumnGallery>
      </Container>
    )
  }

  private handleLoadMore = () => {
    const state = this.props.appcontext.getProductState()
    const action = this.props.appcontext.getProductAction()
    
    const { isFetching, lastFetchedPage } = state
    const { hasMore }  = state

    action.loadMore(isFetching, lastFetchedPage, hasMore)
  }

  private handleSearchBoxChange = (value: string) => {
    this.setState({
      searchKeyword: value
    })
  }

  private isSearching = () => {
    const state = this.state
    return !(state.searchKeyword === "" || state.searchKeyword === undefined || state.searchKeyword === null)
  }
}

export default withAppContext(PageList)